"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

var DLList, Events, Queues;
DLList = require("./DLList");
Events = require("./Events");

Queues = /*#__PURE__*/function () {
  function Queues(num_priorities) {
    _classCallCheck(this, Queues);

    var i;
    this.Events = new Events(this);
    this._length = 0;

    this._lists = function () {
      var _this = this;

      var j, ref, results;
      results = [];

      for (i = j = 1, ref = num_priorities; 1 <= ref ? j <= ref : j >= ref; i = 1 <= ref ? ++j : --j) {
        results.push(new DLList(function () {
          return _this.incr();
        }, function () {
          return _this.decr();
        }));
      }

      return results;
    }.call(this);
  }

  _createClass(Queues, [{
    key: "incr",
    value: function incr() {
      if (this._length++ === 0) {
        return this.Events.trigger("leftzero");
      }
    }
  }, {
    key: "decr",
    value: function decr() {
      if (--this._length === 0) {
        return this.Events.trigger("zero");
      }
    }
  }, {
    key: "push",
    value: function push(job) {
      return this._lists[job.options.priority].push(job);
    }
  }, {
    key: "queued",
    value: function queued(priority) {
      if (priority != null) {
        return this._lists[priority].length;
      } else {
        return this._length;
      }
    }
  }, {
    key: "shiftAll",
    value: function shiftAll(fn) {
      return this._lists.forEach(function (list) {
        return list.forEachShift(fn);
      });
    }
  }, {
    key: "getFirst",
    value: function getFirst() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._lists;
      var j, len, list;

      for (j = 0, len = arr.length; j < len; j++) {
        list = arr[j];

        if (list.length > 0) {
          return list;
        }
      }

      return [];
    }
  }, {
    key: "shiftLastFrom",
    value: function shiftLastFrom(priority) {
      return this.getFirst(this._lists.slice(priority).reverse()).shift();
    }
  }]);

  return Queues;
}();

module.exports = Queues;